import { setToLocalStorage } from './browser-storage';

function refetchAndSyncCart(relay) {
  if (relay && typeof relay.refetch === 'function') {
    relay.refetch({}, null);
    setToLocalStorage('cart', Date.now().toString());
  }
}

export default refetchAndSyncCart;
